define(['./_createSubflowsFromDefns', './_flowBegining', './_wireLOBSection'], (createSubflowsFromDefns, flowBegining, wireLOBSection)=> {
    return ['AvailabilityService', 'qnb.LoadSaveService', '$q', 'TranslateService', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.ErrorHandlingService',
        function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService) {

            function branchOnProductCode(paFlows, hoFlows, cpFlows, flowPropertyKey) {
                const paTransition = paFlows[flowPropertyKey] ? paFlows[flowPropertyKey].entry : null;
                const hoTransition = hoFlows[flowPropertyKey] ? hoFlows[flowPropertyKey].entry : null;
                let cpTransition = null;
                if (cpFlows) {
                    cpTransition = cpFlows[flowPropertyKey] ? cpFlows[flowPropertyKey].entry : null;
                }

                return ({value: submission}) => {
                    if (submission.draftData.productCode === 'PersonalAuto') {
                        return paTransition;
                    }
                    if (submission.draftData.productCode === 'Homeowners') {
                        return hoTransition;
                    }
                    if (submission.draftData.productCode === 'CommercialProperty') {
                        return cpTransition;
                    }
                };
            }

            return function (step, junction, flow) {

                const subFlows = createSubflowsFromDefns(flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ErrorHandlingService);
                //create complete flow by wiring up sub flows
                flowBegining(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
                wireLOBSection(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
            };
        }
    ];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/integration/quoteandbind/config/CompositeFlowConfig.js
 **/